import { useContext, useEffect } from 'react';
import I18nContext from '../../contexts/i18n';

// TODO(moe): Enable this when we are ready.
const ENABLED = false;

const RTLController = () => {
  const i18nSettings = useContext(I18nContext);
  const isRTL = i18nSettings.isLocaleRTL();

  useEffect(() => {
    if (!ENABLED) return;
    window.document.body.dir = isRTL ? 'rtl' : 'ltr';
  }, [isRTL]);

  return null;
};

export default RTLController;
